export const BASE_URL = window.location.protocol + "//" + window.location.host;
// export const STORY_BASE_URL = (window.location.protocol + "//" + window.location.host).replace('www.','story.');

export const STORY_BASE_URL = 'https://story.gyomusuper.it.com';


const Endpoint = {
    POST_TO_ADDRESS: '/api/index/address',
    ME: '/user/getUserinfo',
    
    STORY_DETAIL: '/index.php/api/Tiezi/getTiezi',
    STORY_COMMENT_LIST: '/index.php/api/Pinglun/getPinglunlisttiezi',

    UPLOAD: '/api/common/upload',
    ORDER: '/api/index/index',
    ORDER_DETAIL: '/api/index/getOrderInfoByOrderNo',
    ORDER_UPDATE: '/api/index/updateOrder',
    ORDER_STATUS_UPDATE: '/api/index/customstatus',
    ORDER_SHARE_STATUS: '/api/index/updateOrderShareStatus',
    TRANSLATION: '/api/Urlrelation/getUrlrelationUrl',
    PIXEL: '/api/Urlrelation/getUrlrelationUrl',
    FB_CONVERSION_EVENT: '/api/facebook/EventsAll',
    CUSTOM_EVENT: '/api/Events/addevent',
}
export default Endpoint;

export const DEFAULT_PIXEL_ID = '953316239978099';
export const DEFAULT_FBQ_TOKEN = 'EAAX3e3oqXWMBOZBnFw0QTBtKHTgoVMjTreciUCxmBx88eGx8N5WJA4OeFdF7kPHZBuMZCLbdFr4orQEhfz6e9McmP9alJUwy1JRhSJoPOKrFl5QIZCzfo7If7C06KKOo25xoLzSEZBEOaBMcsXMIibbSZBBcJvyu0QfNVHZByyOOqF94mOmOHLPog1VjVw8qEbCJAZDZD';
